import { Component, Input } from '@angular/core';
import { BillboardChartModel } from './billboardChart.model';

@Component({
    selector: 'dashboard-billboard-chart',
    templateUrl: './billboard-chart.component.html',
    styleUrls: ['./billboard-chart.component.scss'],
    standalone: false
})
export class BillboardChartComponent {
  @Input() billboardChartInfo: BillboardChartModel

  constructor() { }
}
